import * as yup from "yup";
import { TipoProgramaFidelidade } from "../enum/TipoProgramaFidelidade";

export const programaFidelidadeSchema = yup.object().shape({
  tipo: yup.string()
    .oneOf([TipoProgramaFidelidade.CASHBACK, TipoProgramaFidelidade.ITENS], "Tipo de programa inválido")
    .required("O tipo é obrigatório"),
  
  porcentagemRetorno: yup.number()
    .when("tipo", {
      is: TipoProgramaFidelidade.CASHBACK,
      then: (schema) => schema
        .required("A porcentagem de retorno é obrigatória")
        .min(0.01, "A porcentagem deve ser maior que 0")
        .max(100, "A porcentagem não pode ser maior que 100"),
      otherwise: (schema) => schema.nullable().notRequired()
    }),
  
  produtoUuids: yup.array()
    .of(yup.string().required())
    .when("tipo", {
      is: TipoProgramaFidelidade.ITENS,
      then: (schema) => schema
        .required("Selecione pelo menos um produto")
        .min(1, "Selecione pelo menos um produto"),
      otherwise: (schema) => schema.nullable().notRequired()
    }),
  
  quantidadePedidosNecessarios: yup.number()
    .when("tipo", {
      is: TipoProgramaFidelidade.ITENS,
      then: (schema) => schema
        .required("A quantidade de pedidos necessários é obrigatória")
        .min(1, "A quantidade deve ser maior ou igual a 1")
        .integer("A quantidade deve ser um número inteiro"),
      otherwise: (schema) => schema.nullable().notRequired()
    }),

  diasVencimentoCashback: yup.number()
    .when("tipo", {
      is: TipoProgramaFidelidade.CASHBACK,
      then: (schema) => schema
        .nullable()
        .notRequired()
        .min(1, "Deve ser pelo menos 1 dia")
        .integer("Deve ser um número inteiro"),
      otherwise: (schema) => schema.nullable().notRequired()
    }),

  limiteAcumuloCashback: yup.number()
    .when("tipo", {
      is: TipoProgramaFidelidade.CASHBACK,
      then: (schema) => schema
        .nullable()
        .notRequired()
        .min(0.01, "O limite deve ser maior que zero"),
      otherwise: (schema) => schema.nullable().notRequired()
    })
});

